import React from 'react';
import { ShieldCheckIcon, MapPinIcon, CreditCardIcon, StarIcon } from 'lucide-react';
interface TrustBadgeProps {
  icon: 'shield' | 'location' | 'payment' | 'star';
  text: string;
}
export function TrustBadge({
  icon,
  text
}: TrustBadgeProps) {
  const icons = {
    shield: ShieldCheckIcon,
    location: MapPinIcon,
    payment: CreditCardIcon,
    star: StarIcon
  };
  const Icon = icons[icon];
  return <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg border border-slate-200" data-id="element-119">
      <Icon className="w-5 h-5 text-emerald-500" data-id="element-120" />
      <span className="text-sm font-medium text-slate-700" data-id="element-121">{text}</span>
    </div>;
}